module.exports = __webpack_public_path__ + "static/media/maven.4b776819.png";